export const valueOrUndefinedIfEquals = (current, initial) => {
  if (current === initial) return undefined;
  return current;
};

export const valueOrNull = (value) => {
  if (value === undefined) {
    return null;
  }
  return value;
};
